import {
  FieldTypesConfigList,
  FormBuilderInterface,
  FormTypeInterface,
} from '@ckmk/angular';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ContactFormType implements FormTypeInterface {
  public fields: FieldTypesConfigList = [];

  public constructor() {}

  public async configure(builder: FormBuilderInterface): Promise<void> {
    const hasSubject = !!builder.getData('subject');

    builder
      .enableCsrfProtection()
      .add({
        type: 'default',
        name: 'fullName',
        label: 'Full Name',
        required: true,
        config: {
          type: 'text',
        },
      })
      .add({
        type: 'default',
        name: 'email',
        label: 'Email',
        required: true,
        config: {
          type: 'email',
        },
      })
      .add({
        type: 'default',
        name: 'subject',
        label: 'Subject',
        required: true,
        config: {
          type: 'text',
          disabled: hasSubject,
        },
      })
      .add({
        type: 'text',
        name: 'message',
        label: 'Message',
        required: true,
        config: {},
      });
  }
}
